module.exports = __webpack_public_path__ + "img/image90.b034c596.png";